import React, { memo } from 'react';
import './radio-button.scss';

type IradioProps = {
  id?: string;
  name?: string;
  value?: string;
  children?: any;
  label?: string;
  className?: string;
  onChange?: any;
  checkedDefault?: boolean;
};

const RadioButton: React.FC<IradioProps> = (props) => {
  const {
    id,
    name,
    value,
    children,
    label,
    className,
    onChange,
    checkedDefault,
  } = props;
  const isChildren = children !== '';

  return (
    <div className={`ui-form-radio ${className}`} data-testid="radio-button">
      <input
        type="radio"
        className="ui-radio"
        data-testid="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={checkedDefault}
      />
      <label htmlFor={id}>{label}</label>
      {isChildren && children}
    </div>
  );
};

RadioButton.defaultProps = {
  label: '',
  id: '',
  value: '',
  name: '',
  children: '',
  className: '',
  onChange: () => {},
  checkedDefault: false,
};

export default memo(RadioButton);
